import React from 'react';

import './NoticeBlock.scss';


class NoticeBlock extends React.Component {
  render() {
    const {
      type = 'error',
      containerClasses = [],
      children
    } = this.props;

    const classNames = [
      'parkchirp--notice-block',
      `parkchirp--notice-block--${type}`,
      ...containerClasses
    ];

    return (
      <div className={classNames.join(' ').trim()}>
        {children}
      </div>
    );
  }
}
export default NoticeBlock;
